<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-header" style="padding: 10px">
                <b-form @submit.prevent="onSubmit">
                    <b-row>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label_data">Ambulatorio</label>
                            <b-form-select v-model="filtro.idAmbulatorio" :options="ambulatoriOptions" :value="null" value-field="id" text-field="nome"></b-form-select>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label_data">Cognome</label>
                            <b-form-input v-model="filtro.cognome"></b-form-input>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label_data">Nome</label>
                            <b-form-input v-model="filtro.nome"></b-form-input>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label_data">Identificativo</label>
                            <b-form-input v-model="filtro.identificativo"></b-form-input>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label_data">Data Dal</label>
                            <date-picker v-model="filtro.dataDal" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label_data">Data Al</label>
                            <date-picker v-model="filtro.dataAl" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="sa-padding-right text-right">
                            <b-button @click="onClickResetFilter" variant="danger">Reset</b-button>
                            <b-button type="submit" variant="info">Cerca</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Aggiungi Documento</span>
                    <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungiDocumento" class="mb-2">
                        <i class="fas fa-plus"></i>
                        Aggiungi
                    </b-button>

                    <div class="d-flex flex-column">
                        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                            <b-col lg="3">
                                <p>Records Totali: {{ rows }}</p>
                            </b-col>
                            <b-col lg="9">
                                <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                            </b-col>
                        </b-row>
                    </div>

                    <div class="b-table-sticky-header">
                        <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                            <template #cell(index)="row">
                                <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                            </template>
                            <template v-slot:cell(nominativo)="{ item }">
                                <span>{{ item.cognome }} {{ item.nome }}</span>
                            </template>
                            <template v-slot:cell(statoAttualeDataOra)="{ item }">
                                <span>{{ formatDateTime(item.statoAttualeDataOra) }}</span>
                            </template>
                            <template v-slot:cell(dataOra)="{ item }">
                                <span>{{ formatDateTime(item.dataOra) }}</span>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-container class="bv-example-row">
                                    <!-- <template v-if="row.item.statoAttuale === 'INVIATA'"> -->
                                    <b-button v-if="row.item.statoAttuale !== 'DA INVIARE'" v-b-tooltip.hover size="sm" variant="outline-secondary" title="Visualizza" @click="onClickShowDocumento(row.item)" class="mr-1">
                                        <font-awesome-icon icon="eye" />
                                    </b-button>
                                    <b-button v-if="row.item.statoAttuale === 'DA INVIARE'" v-b-tooltip.hover size="sm" variant="outline-success" title="Erogato e non Fatturato" @click="onClickErogato(row.item)">
                                        <font-awesome-icon icon="check"></font-awesome-icon>
                                    </b-button>
                                    <!-- </template>
                                <template v-if="row.item.statoAttuale === 'DA INVIARE'"> -->
                                    <b-button v-if="row.item.statoAttuale === 'DA INVIARE'" v-b-tooltip.hover size="sm" variant="outline-info" title="Compila" @click="onClickEditFattura(row.item)" class="mr-1">
                                        <b-icon icon="pencil"></b-icon>
                                    </b-button>
                                    <!-- </template>
                                <template v-if="row.item.statoAttuale === 'DA INVIARE'"> -->
                                    <b-button v-if="row.item.statoAttuale !== 'INVIATA'" v-b-tooltip.hover size="sm" variant="outline-success" title="Invia a TeamSystem" @click="onClickInvia(row.item)" class="mr-1">
                                        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                                    </b-button>
                                    <!-- </template> -->
                                </b-container>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <team-system-integrator-edit-modal-component ref="cmpTeamsystemIntegratorEditModal" @afterSave="onAfterSave" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></team-system-integrator-edit-modal-component>
        <teamsystem-integrator-view-modal-component ref="cmpTeamsystemIntegratorViewModal" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></teamsystem-integrator-view-modal-component>
    </div>
</template>

<script>
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
import TeamSystemIntegratorEditModalComponent from "./TeamsystemIntegratorEditModalComponent.vue";
import TeamsystemIntegratorViewModalComponent from "./TeamsystemIntegratorViewModalComponent.vue";
export default {
    components: { TeamSystemIntegratorEditModalComponent, TeamsystemIntegratorViewModalComponent, DatePicker }, //, DatePicker
    mixins: [UtilityMixin],
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            filter: null,
            id: "-1",
            items: [],
            rows: 0,
            ambulatoriOptions: [],
            pathResourceAmbulatori: "/ambulatoriutenti",
            filtro: { idAmbulatorio: null, nome: null, cognome: null, identificativo: null, dataDal: null, dataAl: null },
            pathResource: "/teamsystemintegratorresponse",
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Nominativo",
                    key: "nominativo",
                },
                {
                    label: "Prestazione",
                    key: "prestazione",
                },
                {
                    label: "Stato Attuale",
                    key: "statoAttuale",
                },
                {
                    label: "Data Ora",
                    key: "statoAttualeDataOra",
                },
                {
                    label: "Data Ora Trattamento",
                    key: "dataOra",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        init() {
            this.loadAmbulatori();
        },
        onSubmit() {
            this.loadData();
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            // console.log(me.filtro);

            me.filtro.forPage = me.perPage;
            me.filtro.page = me.currentPage;

            this.loadDataResources(this.pathResource, this.filtro, this.loadDataSuccess, this.loadDataError);
            me.$emit("afterLoadData");
        },
        loadDataSuccess(response) {
            this.items = response.data.data.list;
            console.log("loadDataSuccess", this.items);
            this.rows = response.data.data.recordsNumber;
            this.$emit("afterLoadData");
        },
        loadDataError(error) {
            error;
            this.$emit("afterLoadData");
        },
        onClickResetFilter() {
            this.filtro = { idAmbulatorio: null, nome: null, cognome: null, identificativo: null, dataDal: null, dataAl: null };
            this.loadAmbulatori();
        },
        onClickShowDocumento(item) {
            this.$refs.cmpTeamsystemIntegratorViewModal.init(item.id);
        },
        onClickErogato(item) {
            let me = this;
            item.statoAttuale = "EROGATA";
            me.saveResource(
                this.pathResource + "/aggiornastato",
                item,
                () => me.loadData(),
                (err) => {
                    err;
                },
            );
        },
        onClickEditFattura(item) {
            this.$refs.cmpTeamsystemIntegratorEditModal.init(item.id);
        },
        onClickInvia(item) {
            let me = this;
            // me.$emit("beforeLoadData");
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/invia/" + item.id;
            UtilityMixin.methods.restCallPut(link, null, me.inviaResponse, me.inviaError);
            // this.$emit("afterLoadData");
        },
        inviaResponse(response) {
            response;
            // this.$emit("afterLoadData");
            this.loadData();
        },
        inviaError(response) {
            // this.$emit("afterLoadData");
            if (response.response.status === 400) {
                this.$emit("errorRestCall", response);
            } else {
                this.$bvToast.toast("Errore nel salvarei dati del Piano: " + response.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        onAfterSave() {
            let me = this;
            // me.$emit("afterLoadData");
            me.loadData();
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
        },
        onClickAggiungiDocumento() {
            this.$refs.cmpTeamsystemIntegratorEditModal.init(null);
        },
        loadAmbulatori() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbulatori;
            me.ambulatoriOptions = [];
            axios.get(link).then((response) => {
                me.ambulatoriOptions = response.data.data;
                if (me.ambulatoriOptions.length > 1) {
                    this.filtro.idAmbulatorio = me.ambulatoriOptions.map((element) => element.id).join("#");
                    if (this.filtro.idAmbulatorio) {
                        this.filtro.idAmbulatorio = this.filtro.idAmbulatorio.slice(0, -1);
                    }
                    me.ambulatoriOptions.unshift({ id: null, nome: "-Seleziona Valore-" });
                    this.loadData();
                } else if (me.ambulatoriOptions.length === 1) {
                    me.filtro.idAmbulatorio = me.ambulatoriOptions[0].id;
                    this.loadData();
                }
            });
        },
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
.sa-card-list {
    padding: 2rem;
    margin-bottom: 100px;
}
</style>
